import ReactPlayer from 'react-player';
import styled from 'styled-components';

const videoSrcs = ['https://youtu.be/FThWge7Ya2w', 'https://youtu.be/EleoEhKhG90'];

const AcceleratorVideoCarousel = () => {
  return (
    <CarouselWrapper>
      <ReactPlayer
        style={{ borderRadius: 10, overflow: 'hidden', margin: '10px 10px' }}
        controls
        url={videoSrcs[0]}
        height={350}
        width="fit-content"
      />
      <ReactPlayer
        style={{ borderRadius: 10, overflow: 'hidden', margin: '10px 10px' }}
        controls
        url={videoSrcs[1]}
        height={350}
        width="fit-content"
      />
    </CarouselWrapper>
  );
};

const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 765px;
  position: relative;
  div {
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
  margin: 0 auto;

  @media (max-width: 900px) {
    padding: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
    margin-right: 0px;
    width: 100%;
  }

  @media (max-width: 900px) {
    display: flex;
    flex-wrap: wrap;
  }
`;

export default AcceleratorVideoCarousel;
